import { Loader, Text } from "@certn/cascadia-react";
import { css, cx } from "@emotion/css";
import { PropsWithChildren } from "react";

export interface DashboardCardProps extends PropsWithChildren {
  title?: string | React.ReactNode;
  className?: string;
  trailing?: React.ReactNode;
  testID?: string;
  isLoading?: boolean;
  minHeight?: number;
}

export function DashboardCard(props: DashboardCardProps) {
  const { title, children, className, testID = "dashboard-card" } = props;

  return (
    <section
      aria-label={`${testID}-container`}
      data-testid={testID}
      className={cx(styles.container, className)}
      style={{
        minHeight: props.minHeight,
      }}
    >
      {title && (
        <div
          className={css(props.trailing ? styles.titleWithTrailing : undefined)}
        >
          {typeof title === "string" ? (
            <Text as="h2" style="global/heading-large">
              {title}
            </Text>
          ) : (
            title
          )}
          {props.trailing}
        </div>
      )}
      {children}
      {props.isLoading && <Loader overlay />}
    </section>
  );
}

const styles = {
  container: css({
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "var(--border-radius-3)",
    display: "flex",
    gap: "var(--space-3)",
    flexDirection: "column",
    padding: "var(--space-5)",
    borderColor: "var(--border-base)",
    backgroundColor: "var(--surface-base)",
    position: "relative",
  }),
  titleWithTrailing: css({
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
  }),
};
